var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banners-components'),_c('header-site'),_c('about-components'),_c('solutions-components'),_c('footer-site')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }